<template>
  <div class="editBread">
    <a-breadcrumb>
      <template v-if="queryParams?.type - 0 !== 2">
        <a-breadcrumb-item @click="jumpPage">公共功能配置</a-breadcrumb-item>
        <a-breadcrumb-item>{{ queryParams.name }}</a-breadcrumb-item>
      </template>
      <template v-else>
        <a-breadcrumb-item>
          <router-link :to="{ path: '/PublicSet', query: detailParams }"
            >公共功能配置</router-link
          >
        </a-breadcrumb-item>
        <a-breadcrumb-item>
          <router-link :to="{ path: '/TopBarList', query: detailParams }"
            >Topbar列表</router-link
          >
        </a-breadcrumb-item>
        <a-breadcrumb-item>Topbar详情</a-breadcrumb-item>
      </template>
    </a-breadcrumb>
  </div>
</template>
<script>
import { computed, inject, toRefs } from 'vue'
import { cloneDeep, pick } from 'lodash-es'
export default {
  setup() {
    const initState = inject('initState')
    const detailParams = computed(() => {
      const result = cloneDeep(initState?.route?.query)
      return pick(result, ['terminalId', 'brandId', 'channelId', 'siteId'])
    })
    console.log('detailParams', detailParams)
    return {
      ...toRefs(initState),
      detailParams
    }
  }
}
</script>
<style lang="scss" scoped>
.editBread {
  background: #ffffff;
  margin: 15px;
  padding: 15px 20px;
}
</style>
